import styled from 'styled-components';

export const LogoStyled = styled.svg`
  width: ${props => props.size};
  fill: ${props =>
    props.negativeVersion
      ? props.theme.color.wfWhite
      : props.theme.color.wfBlack};
  overflow: ${props => props.label && 'visible'};
  cursor: pointer;
`;
